import React, { useEffect } from 'react';
import { Row, Col, Divider, Form, DatePicker, InputNumber } from 'antd';
import dayjs from 'dayjs';

// Date format constant
const DATE_FORMAT_DISPLAY = 'YYYY/MM/DD';


const ValidityPeriodSection = ({ form, isEdit, initialValues }) => {


  // Set up initial form values
  useEffect(() => {
    if (isEdit && initialValues) {
      const activationDate = initialValues.activation_date 
        ? dayjs(initialValues.activation_date).startOf('day')
        : dayjs().startOf('day');
      
      const expiryDate = initialValues.expiry_date 
        ? dayjs(initialValues.expiry_date).startOf('day')
        : dayjs().startOf('day').add(1, 'year');
     
      form.setFieldsValue({
        activation_date: activationDate,
        expiry_date: expiryDate,
        grace_period_days: initialValues.grace_period_days || 30,
      });
    } else if (!isEdit) {
      const today = dayjs().startOf('day');
      form.setFieldsValue({
        activation_date: today,
        expiry_date: today.add(1, 'year')
        //grace_period_days: 30
      });
    }
  }, [form, isEdit, initialValues]);

  const disabledActivationDate = (current) => {
    return current && current.isBefore(dayjs().startOf('day'), 'day');
  };

  const disabledExpiryDate = (current) => {
    const activationDate = form.getFieldValue('activation_date');
    if (!activationDate || !current) return false;
    return current && current.startOf('day').isBefore(dayjs(activationDate).startOf('day'));
  };

  const handleDateChange = (field, date) => {
    if (!date || !dayjs(date).isValid()) return;
    
    const newDate = dayjs(date).startOf('day');
    const updates = { [field]: newDate };
    
    // If activation date changes and is after expiry date, update expiry date
    if (field === 'activation_date') {
      const expiryDate = form.getFieldValue('expiry_date');
      if (!expiryDate || dayjs(expiryDate).isBefore(newDate, 'day')) {
        updates.expiry_date = newDate.add(1, 'year');
      }
    }
    
    form.setFieldsValue(updates);
  };



  return (
    <>
      <Divider orientation="left">Validity Period</Divider>

      <Row gutter={12}>
        {/* Activation Date */}
        <Col xs={24} md={8}>
          <Form.Item
            label="Activation Date"
            name="activation_date"
            rules={[{ required: true, message: 'Please select an activation date' }]}
          >
            <DatePicker
              style={{ width: '100%' }}
              disabledDate={disabledActivationDate}
              format={DATE_FORMAT_DISPLAY}
              showToday
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(date) => handleDateChange('activation_date', date)}
              placeholder="Select activation date"
              className="date-picker-fix"
              value={form.getFieldValue('activation_date')}
            />
          </Form.Item>
        </Col>

        {/* Expiry Date */}
        <Col xs={24} md={8}>
          <Form.Item
            label="Expiry Date"
            name="expiry_date"
            rules={[
              {
                validator(_, value) {
                  const activationDate = form.getFieldValue('activation_date');
                  if (!value || !activationDate) return Promise.resolve();
                  if (dayjs(value).isAfter(dayjs(activationDate), 'day') || dayjs(value).isSame(dayjs(activationDate), 'day')) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Expiry date must be on or after activation date'));
                },
              },
            ]}
          >
            <DatePicker
              style={{ width: '100%' }}
              disabledDate={disabledExpiryDate}
              format={DATE_FORMAT_DISPLAY}
              showToday
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(date) => handleDateChange('expiry_date', date)}
              placeholder="Select expiry date"
              className="date-picker-fix"
              value={form.getFieldValue('expiry_date')}
            />
          </Form.Item>
        </Col>

        {/* Grace Period */}
        <Col xs={24} md={8}>
          <Form.Item
            label="Grace Period (Days)"
            name="grace_period_days"
            extra="Number of days after expiry before license is marked as expired"
          >
            <InputNumber
              min={0}
              style={{ width: '100%' }}
              placeholder="Enter grace period in days"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default ValidityPeriodSection;
